import { useContext } from 'react';

import { AccountProfileContext } from './AccountProfileContext';

export const useAccountProfileContext = () => {
  const context = useContext(AccountProfileContext);
  if (!context) {
    throw new Error('useAccountProfileContext must be used within an AccountProfileProvider');
  }
  return context;
};
